import React from "react";
import { ArrowLeft } from "lucide-react";
import { CallDetailPanel } from "@/components/CallDetailPanel";

// Mobile: full-screen. Tablet (md): right slide-over with backdrop. Hidden on desktop (lg+).
export const CallDetailOverlay = ({ call, onClose }) => {
  if (!call) return null;
  return (
    <div className="lg:hidden" data-testid="call-detail-overlay">
      <div
        className="hidden md:block fixed inset-0 bg-slate-900/40 z-40"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="fixed z-50 bg-slate-50 overflow-y-auto inset-0 md:inset-y-0 md:right-0 md:left-auto md:w-[440px] md:border-l md:border-slate-200 md:shadow-2xl animate-in fade-in slide-in-from-right-4 duration-200">
        <div className="sticky top-0 z-10 bg-white/90 backdrop-blur border-b border-slate-200 px-3 py-2.5 flex items-center gap-2">
          <button
            type="button"
            data-testid="call-detail-back"
            onClick={onClose}
            className="h-11 w-11 inline-flex items-center justify-center rounded-full text-slate-700 active:bg-slate-100"
            aria-label="Retour"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <p className="font-heading font-semibold text-slate-900">Détail de l'appel</p>
        </div>
        <div className="p-4 pb-28 md:pb-6">
          <CallDetailPanel call={call} />
        </div>
      </div>
    </div>
  );
};
